import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { QA_NAME_PROFILE_INFO_ITEM_VALUE } from '../../../../constants/qa'
import { EntityProfileHeaderInfoItemBase } from '../../../Entity'
import { RequestTagMultiValuedList } from '../../../Request'
import { TAG_HEIGHT } from '../../../Tag'
import Text from '../../../Text'

import * as styles from './DocFlowProfileHeaderConnectedRequests.module.css'

function DocFlowProfileHeaderConnectedRequests({
  noDataText,
  value = EMPTY_LIST,
  onRemoveRequest,
  ...restProps
}) {
  const { t } = useTranslation()

  const removeProps = onRemoveRequest
    ? {
        removeTooltipKey: 'DocFlow.ProfileConnectedRequestRemoveTooltipKey',
        onRemove: onRemoveRequest,
      }
    : null

  return (
    <EntityProfileHeaderInfoItemBase
      {...restProps}
      contentExist={value.length > 0}
      value={value}
    >
      {value.length > 0 ? (
        <RequestTagMultiValuedList
          className={styles.list}
          itemProps={{ ...removeProps, height: TAG_HEIGHT.height28 }}
          items={value}
          moreItemsProps={{ itemProps: removeProps }}
        />
      ) : (
        <Text disabled isSecondary qaName={QA_NAME_PROFILE_INFO_ITEM_VALUE}>
          {t(noDataText)}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default DocFlowProfileHeaderConnectedRequests
